import { InvitationWizard } from "../components/wizard";

const CreateInvitationPage = () => {
  return <InvitationWizard />;
};

export default CreateInvitationPage;
